import React, { useContext, useState } from 'react';
import { Snackbar, IconButton, SnackbarContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import emailjs from 'emailjs-com';
import isEmail from 'validator/lib/isEmail';
import { makeStyles } from '@mui/styles';
// import {
//     FaTwitter,
//     FaLinkedinIn,
//     FaGithub,
//     FaYoutube,
//     FaBloggerB,
//     FaRedditAlien,
//     FaStackOverflow,
//     FaCodepen,
//     FaInstagram,
//     FaGitlab,
//     FaMediumM,
// } from 'react-icons/fa';
import { AiOutlineSend, AiOutlineCheckCircle } from 'react-icons/ai';
import { FiPhone, FiAtSign } from 'react-icons/fi';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { ThemeContext } from '../../contexts/ThemeContext';

// import { socialsData } from '../../data/socialsData';
import { contactsData } from '../../data/contactsData';
import './Contacts.css';

// Configuration EmailJS
const EMAIL_CONFIG = {
  USER_ID: 'YdMJ1IEvi8B-2m3EX', // Remplacez par votre USER_ID
  SERVICE_ID: 'service_q9utzds', // Remplacez par votre SERVICE_ID
  TEMPLATE_ID: 'template_58kuizn' // Remplacez par votre TEMPLATE_ID
};

// Fonction principale d'envoi d'email
export const sendEmailDirect = async (templateParams) => {
  try {
    console.log('Envoi en cours avec les paramètres:', templateParams);
    
    const response = await emailjs.send(
      EMAIL_CONFIG.SERVICE_ID,
      EMAIL_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAIL_CONFIG.USER_ID
    );
    
    console.log('✅ Email envoyé avec succès:', response);
    return { 
      success: true, 
      data: response,
      message: 'Email envoyé avec succès !' 
    };
  } catch (error) {
    console.error('❌ Erreur lors de l\'envoi:', error);
    return { 
      success: false, 
      error: error.message || 'Erreur inconnue',
      message: 'Échec de l\'envoi de l\'email' 
    };
  }
};

function Contacts() {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const [success, setSuccess] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const { theme } = useContext(ThemeContext);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const useStyles = makeStyles((t) => ({
        input: {
            border: `1px solid ${theme.fourthly}`,
            backgroundColor: `${theme.primary}`,
            color: `${theme.secondary}`,
            fontFamily: 'var(--primaryFont)',
            fontWeight: 500,
            transition: 'border 0.2s ease-in-out',
            '&:focus': {
                border: `1px solid ${theme.tertiary }`,
            },
            [t.breakpoints.down('sm')]: {
                fontSize: '0.95rem',
            },
        },
        message: {
            border: `1px solid ${theme.fourthly}`,
            backgroundColor: `${theme.primary}`,
            color: `${theme.secondary}`,
            fontFamily: 'var(--primaryFont)',
            fontWeight: 500,
            transition: 'border 0.2s ease-in-out',
            '&:focus': {
                border: `1px solid ${theme.tertiary}`,
            },
            [t.breakpoints.down('sm')]: {
                fontSize: '0.95rem',
            },
        },
        label: {
            backgroundColor: `${theme.primary}`,
            color: `${theme.secondary}`,
            fontFamily: 'var(--primaryFont)',
            fontWeight: 'normal',
            fontSize: '1.15rem',
            padding: '0 5px',
            transform: 'translate(25px,50%)',
            display: 'inline-flex',
            [t.breakpoints.down('sm')]: {
                fontSize: '0.95rem',
            },
        },
      
        detailsIcon: {
            backgroundColor: theme.primary,
            color: theme.secondary,
            borderRadius: '50%',
            width: '45px',
            height: '45px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '23px',
            transition: '250ms ease-in-out',
            flexShrink: 0,
            '&:hover': {
                transform: 'scale(1.1)',
                color: theme.secondary,
                backgroundColor: theme.tertiary,
            },
        },
        submitBtn: {
            backgroundColor: theme.primary,
            color: theme.secondary,
            border: `1px solid ${theme.fourthly}`,
            transition: '250ms ease-in-out',
            '&:hover': {
                transform: 'scale(1.08)',
                color: theme.primary,
                backgroundColor: theme.secondary,
            },
            [t.breakpoints.down('sm')]: {
                fontSize: '0.95rem !important',
            },
        },
    }));

    const classes = useStyles();

    const handleContactForm = async(e) => {
        e.preventDefault();

        if (name && email && message) {
            if (isEmail(email)) {
                const responseData = {
                    name: name,
                    email: email,
                    message: message,
                };

                 // 📝 Préparation des données pour EmailJS
                const templateParams = {
                    from_name: responseData.name,
                    from_email: responseData.email,
                    message: responseData.message,
                };

                console.log('📤 Envoi des données:', templateParams);

                try {
                    // 🔗 APPEL DE LA FONCTION sendEmailDirect
                    const result = await sendEmailDirect(templateParams);
        
                    if (result.success) {
                        setErrMsg('✅ ' + result.message);
                        // Réinitialisation du formulaire
                        setSuccess(true);
                        setErrMsg('');

                        setName('');
                        setEmail('');
                        setMessage('');
                        setOpen(false);
                    } else {
                        setErrMsg('❌ ' + result.message + ': ' + result.error);
                    }
                } catch (error) {
                    setErrMsg('❌ Erreur inattendue: ' + error.message);
                    console.error('Erreur lors de la soumission:', error);
                } finally {
                    setOpen(false);
                }
            } else {
                setErrMsg('Votre email est invalide');
                setOpen(true);
            }
        } else {
            setErrMsg('Veuillez remplir tous les champs');
            setOpen(true);
        }
    };

    return (
        <div
            className='contacts'
            id='contacts'
            style={{ backgroundColor: theme.primary }}
        >
            <div className='contacts--container'>
                {/* <h1 style={{ color: theme.tertiary }}>Me contacter</h1> */}
                <div className='contacts-body'>
                    {<div className='contacts-form'>
                        <form onSubmit={handleContactForm}>
                            <div className='input-container'>
                                <label htmlFor='name' className={classes.label}>
                                    Votre nom
                                </label>
                                <input
                                    placeholder='Votre nom'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    type='text'
                                    name='Name'
                                    id='name'
                                    className={`form-input ${classes.input}`}
                                />
                            </div>
                            <div className='input-container'>
                                <label
                                    htmlFor='email'
                                    className={classes.label}
                                >
                                    Votre email
                                </label>
                                <input
                                    placeholder='Votre email'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type='email'
                                    name='Email'
                                    id='email'
                                    className={`form-input ${classes.input}`}
                                />
                            </div>
                            <div className='input-container'>
                                <label
                                    htmlFor='message'
                                    className={classes.label}
                                >
                                    Votre message
                                </label>
                                <textarea
                                    placeholder='Saisissez votre message....'
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    type='text'
                                    name='Message'
                                    id='message'
                                    className={`form-message ${classes.message}`}
                                />
                            </div>

                            <div className='submit-btn'>
                                <button
                                    type='submit'
                                    className={classes.submitBtn}
                                >
                                    <p>{!success ? 'Envoyer' : 'Envoyé'}</p>
                                    <div className='submit-icon'>
                                        <AiOutlineSend
                                            className='send-icon'
                                            style={{
                                                animation: !success
                                                    ? 'initial'
                                                    : 'fly 0.8s linear both',
                                                position: success
                                                    ? 'absolute'
                                                    : 'initial',
                                            }}
                                        />
                                        <AiOutlineCheckCircle
                                            className='success-icon'
                                            style={{
                                                display: !success
                                                    ? 'none'
                                                    : 'inline-flex',
                                                opacity: !success ? '0' : '1',
                                            }}
                                        />
                                    </div>
                                </button>
                            </div>
                        </form>
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            open={open}
                            autoHideDuration={4000}
                            onClose={handleClose}
                        >
                            <SnackbarContent
                                action={
                                    <React.Fragment>
                                        <IconButton
                                            size='small'
                                            aria-label='close'
                                            color='inherit'
                                            onClick={handleClose}
                                        >
                                            <CloseIcon fontSize='small' />
                                        </IconButton>
                                    </React.Fragment>
                                }
                                style={{
                                    backgroundColor: theme.primary,
                                    color: theme.secondary,
                                    fontFamily: 'var(--primaryFont)',
                                }}
                                message={errMsg}
                            />
                        </Snackbar>
                    </div>}

                    <div className='contacts-details'>
                        <a
                            href={`mailto:${contactsData.email}`}
                            className='personal-details'
                        >
                            <div className={classes.detailsIcon}>
                                <FiAtSign />
                            </div>
                            <p style={{ color: theme.secondary }}>
                                {contactsData.email}
                            </p>
                        </a>
                        <a
                            href={`tel:${contactsData.phone}`}
                            className='personal-details'
                        >
                            <div className={classes.detailsIcon}>
                                <FiPhone />
                            </div>
                            <p style={{ color: theme.secondary }}>
                                {contactsData.phone}
                            </p>
                        </a>
                        <div className='personal-details'>
                            <div className={classes.detailsIcon}>
                                <HiOutlineLocationMarker />
                            </div>
                            <p style={{ color: theme.secondary }}>
                                {contactsData.address}
                            </p>
                        </div>

                        <div className='socialmedia-icons'>
                            {/* {socialsData.twitter && (
                                <a
                                    href={socialsData.twitter}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaTwitter aria-label='Twitter' />
                                </a>
                            )} */}
                            {/* {socialsData.github && (
                                <a
                                    href={socialsData.github}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaGithub aria-label='GitHub' />
                                </a>
                            )} */}
                            {/* {socialsData.linkedIn && (
                                <a
                                    href={socialsData.linkedIn}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaLinkedinIn aria-label='LinkedIn' />
                                </a>
                            )} */}
                            {/* {socialsData.instagram && (
                                <a
                                    href={socialsData.instagram}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaInstagram aria-label='Instagram' />
                                </a>
                            )}*/}
                            {/* {socialsData.medium && (
                                <a
                                    href={socialsData.medium}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaMediumM aria-label='Medium' />
                                </a>
                            )} */}
                            {/*
                            {socialsData.blogger && (
                                <a
                                    href={socialsData.blogger}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaBloggerB aria-label='Blogger' />
                                </a>
                            )}
                            {socialsData.youtube && (
                                <a
                                    href={socialsData.youtube}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaYoutube aria-label='YouTube' />
                                </a>
                            )}
                            {socialsData.reddit && (
                                <a
                                    href={socialsData.reddit}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaRedditAlien aria-label='Reddit' />
                                </a>
                            )}
                            {socialsData.stackOverflow && (
                                <a
                                    href={socialsData.stackOverflow}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaStackOverflow aria-label='Stack Overflow' />
                                </a>
                            )}
                            {socialsData.codepen && (
                                <a
                                    href={socialsData.codepen}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaCodepen aria-label='CodePen' />
                                </a>
                            )}
                            {socialsData.gitlab && (
                                <a
                                    href={socialsData.gitlab}
                                    target='_blank'
                                    rel='noreferrer'
                                    className={classes.socialIcon}
                                >
                                    <FaGitlab aria-label='GitLab' />
                                </a>
                            )} */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <img
                src={theme.contactsimg}
                alt='contacts'
                className='contacts--img'
            /> */}
        </div>
    );
}

export default Contacts;
